import { render } from "./DrawingBoard.vue?vue&type=template&id=19353408&scoped=true"
import script from "./DrawingBoard.vue?vue&type=script&lang=js"
export * from "./DrawingBoard.vue?vue&type=script&lang=js"

import "./DrawingBoard.vue?vue&type=style&index=0&id=19353408&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19353408"]])

export default __exports__